<script setup>
import { store } from "./store.vue";
import DragAndDrop from "./DragAndDrop.vue";
import CameraCapture from "./CameraCapture.vue";
/** Komponente zum Hochladen von Attachments via Drag'n Drop  (WIRD ZUR ZEIT NICHT VERWENDET)
 * @displayName Service zum Datei-Upload
 */
</script>
<script>
export default {
  name: "DokumenteHochladenService",
  components: {
    // myRouter: router,
    DragAndDrop,
    CameraCapture,
  },
  data() {
    return {
      store,
    };
  },
  mounted() {
    this.$servertalk.doLog("s this.defaultData");
    this.$servertalk.doLog(this.defaultData);
    this.$servertalk.doLog(this.formId);
  },
  methods: {
    status(s) {
      this.$emit("status", s);
      //s.uploadStatus = s.uploadStatus + '+';
    },
    isOk(s) {
      this.$emit("isOk", s, this.lfn);
    },
    newfiles(s) {
      this.$servertalk.doLog("newfiles");
      this.$servertalk.doLog(s);
      this.$emit("newfiles", s, this.lfn);
      this.$servertalk.doLog(store.draft);
    },
    change(s) {
      this.$servertalk.doLog("change");
      this.$servertalk.doLog(s);
      this.$emit("change", s, this.lfn);
      this.$servertalk.doLog(store.draft);
    },
  },
  emits: ["change", "status", "isOk", "newfiles"],
  props: {
    formId: {
      type: String,
      required: true,
    },
    isSubdata: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultData: {
      type: Array,
      required: true,
    },
    infoText: {
      type: String,
      default: "Upload",
    },
    docArt: {
      type: String,
      default: "Document",
    },
    maxfiles: {
      default: 1,
    },
    minfiles: {
      default: 0,
    },
    lfn: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<template>
  <div class="">
    <DragAndDrop
      :formId="formId"
      :isSubdata="isSubdata"
      :infoText="infoText"
      :docArt="docArt"
      :maxfiles="parseInt(maxfiles)"
      :minfiles="parseInt(minfiles)"
      :defaultData="defaultData"
      @status="status"
      @isOk="isOk"
      @newfiles="newfiles"
      @change="change" />
  </div>
</template>
